var $ = require('jquery');

module.exports = {
	init: function () {
		// trigger function when DOM is ready
		window.addEventListener('load', function () {
			console.log('Menu functionality loaded!');
			const mobileWidth = 1080;

			//* Find all menu items and add tabindex 0 to them
			$('.main-menu > .menu-item > a').attr('tabindex', '0');

			const addSubmenuExpandedClass = function () {
				// console.log("addSubmenuExpandedClass");
				$('header').addClass('submenu-expanded');
				$(this).addClass('submenu-expanded');
				$(this).parentsUntil('.main-menu').last().addClass('submenu-expanded');
			};

			const removeSubmenuExpandedClass = () => {
				// console.log("removeSubmenuExpandedClass");
				$('header').removeClass('submenu-expanded');
				$('.submenu-expanded').removeClass('submenu-expanded');
			};

			const handleSubmenuScroll = function (event) {
				const submenu = $(event.currentTarget);
				// console.log('🚀 ~ file: menu.js:71 ~ handleSubmenuScroll ~ submenu:', submenu);

				// console.log(
				// '🚀 ~ file: menu.js:77 ~ handleSubmenuScroll ~ submenu.scrollLeft() :',
				// submenu.scrollLeft()
				// );
				//* If the submenu is scrolled all the way to the left, hide the left arrow
				if (submenu.scrollLeft() === 0) {
					submenu.children('.submenu-arrow-left').addClass('hidden');
				} else {
					submenu.children('.submenu-arrow-left').removeClass('hidden');
				}
				// console.log(
				// '🚀 ~ file: menu.js:84 ~ handleSubmenuScroll ~ submenu.scrollLeft()',
				// submenu.scrollLeft()
				// );

				console.log(submenu.width());

				//* Get padding right and left of submenu
				const submenuPaddingRight = parseInt(submenu.css('padding-right'));
				// console.log(
				// '🚀 ~ file: menu.js:49 ~ handleSubmenuScroll ~ submenuPaddingRight:',
				// submenuPaddingRight
				// );
				const submenuPaddingLeft = parseInt(submenu.css('padding-left'));
				// console.log(
				// '🚀 ~ file: menu.js:50 ~ handleSubmenuScroll ~ submenuPaddingLeft:',
				// submenuPaddingLeft
				// );

				// console.log(
				// '🚀 ~ file: menu.js:85 ~ handleSubmenuScroll ~ submenu[0].scrollWidth:',
				// submenu[0].scrollWidth
				// );
				// console.log(
				// "🚀 ~ file: menu.js:93 ~ handleSubmenuScroll ~ submenu.children('.submenu-arrow-right'):",
				// submenu.children('.submenu-arrow-right')
				// );
				//* If the submenu is scrolled all the way to the right, hide the right arrow
				console.log(
					'🚀 ~ file: menu.js:69 ~ handleSubmenuScroll ~ submenu.scrollLeft() + submenu.width() + submenuPaddingLeft + submenuPaddingRight:',
					submenu.scrollLeft() +
						submenu.width() +
						submenuPaddingLeft +
						submenuPaddingRight
				);
				console.log(
					'🚀 ~ file: menu.js:82 ~ handleSubmenuScroll ~ submenu[0].scrollWidth:',
					submenu[0].scrollWidth
				);

				if (
					Math.round(
						submenu.scrollLeft() +
							submenu.width() +
							submenuPaddingLeft +
							submenuPaddingRight
					) >= submenu[0].scrollWidth
				) {
					submenu.children('.submenu-arrow-right').addClass('hidden');
				} else {
					submenu.children('.submenu-arrow-right').removeClass('hidden');
				}
			};

			//* Create Arrows for submenu to scroll through
			const createSubmenuArrows = function () {
				// console.log("createSubmenuArrows");
				const submenus = $('.main-menu > .menu-item > .sub-menu');
				// console.log('🚀 ~ file: menu.js:29 ~ createSubmenuArrows ~ submenus:', submenus);

				submenus.each(function (index, submenu) {
					submenu = $(submenu);
					const submenuItems = $(submenu).children('.menu-item');
					const submenuItemsLength = submenuItems.length;

					//* If there are more than 2 submenu items, create arrows
					if (submenuItemsLength <= 2) return;

					//* Create arrows
					const leftArrow = $('<div>', {
						class: 'submenu-arrow submenu-arrow-left',
						title: 'Scroll left'
					})
						.appendTo(submenu)
						.click(function () {
							console.log('leftArrow clicked');

							console.log(submenu);

							// scroll 100px to the left
							submenu.scrollLeft(submenu.scrollLeft() - 300);
							handleSubmenuScroll({currentTarget: submenu});
						});

					const rightArrow = $('<div>', {
						class: 'submenu-arrow submenu-arrow-right',
						title: 'Scroll right'
					})
						.appendTo(submenu)
						.click(function () {
							console.log('rightArrow clicked');

							// scroll 100px to the right
							submenu.scrollLeft(submenu.scrollLeft() + 300);
							handleSubmenuScroll({currentTarget: submenu});
						});

					handleSubmenuScroll({currentTarget: submenu});
				});
			};

			this.window.innerWidth > mobileWidth && createSubmenuArrows();

			//* Add event listeners to submenu scroll
			$('.main-menu > .menu-item > .sub-menu').on('scroll', handleSubmenuScroll);

			//* Add event listeners to resize
			$(window).on('resize', function () {
				$('.main-menu > .menu-item > .sub-menu').each(function (index, submenu) {
					handleSubmenuScroll({currentTarget: submenu});
				});
			});

			//* MOBILE MENU *//
			const $mobileMenuToggle = $('#nav-toggle');

			const expandMobileMenu = (event) => {
				const parent = $(event.currentTarget).parent(); // menu-item
				const menuHasChildren = parent.hasClass('menu-item-has-children');
				if (!menuHasChildren) return;

				event.preventDefault && event.preventDefault();

				// Remove any existing ready-to-expand classes
				$('.ready-to-expand').removeClass('ready-to-expand');

				parent.addClass('ready-to-expand');
				parent
					.parentsUntil('.main-menu', '.menu-item')
					.addClass('mobile-child-menu-expanded');

				const siblingMenuItems = parent.siblings();

				siblingMenuItems.each(function (index, item) {
					$(item).addClass('mobile-sibling-menu-expanded');
				});
			};

			const collapseMobileMenu = function (event) {
				const parent = $(event.currentTarget).parent(); // menu-item
				$('.ready-to-expand').removeClass('ready-to-expand');

				const openMenuDepth = parent.parentsUntil(
					'.main-menu',
					'.mobile-child-menu-expanded'
				);
				parent
					.parentsUntil('.main-menu', '.menu-item')
					.removeClass('mobile-child-menu-expanded');

				const siblingMenuItems = parent.siblings();

				siblingMenuItems.each(function (index, item) {
					$(item).removeClass('mobile-sibling-menu-expanded');
				});

				if (openMenuDepth.length > 0) {
					expandMobileMenu({
						currentTarget: openMenuDepth.last().children('a'),
						target: openMenuDepth.last().children('a')
					});
				}
			};

			//* create function that collapses all mobile menus
			const collapseAllMobileMenus = function () {
				$('.mobile-child-menu-expanded').removeClass('mobile-child-menu-expanded');
				$('.mobile-sibling-menu-expanded').removeClass('mobile-sibling-menu-expanded');
				$('.ready-to-expand').removeClass('ready-to-expand');

				//* Detach any existing back buttons
				$('.mobile-menu-back-button').detach();
			};

			const createMobileBackButton = function (event) {
				const parent = $(event.target).parent(); // menu-item
				const headerNav = $('header .header-nav');

				// Create new back button in headerNav element
				const buttonSvg = `<svg width="98" height="92" viewBox="0 0 98 92" fill="black" xmlns="http://www.w3.org/2000/svg">
					<rect y="0.354736" width="97.6846" height="91.6453" fill="white"/>
					<g opacity="0.5" fill=black>
					<path d="M29.536 46.6288C28.7549 47.4098 28.7549 48.6761 29.536 49.4572L42.2639 62.1851C43.045 62.9662 44.3113 62.9662 45.0923 62.1851C45.8734 61.4041 45.8734 60.1377 45.0923 59.3567L33.7786 48.043L45.0923 36.7293C45.8734 35.9482 45.8734 34.6819 45.0923 33.9008C44.3113 33.1198 43.045 33.1198 42.2639 33.9008L29.536 46.6288ZM30.9502 50.043H73.704V46.043H30.9502V50.043Z" fill="black"/>
					</g>
					</svg>`;

				const backButton = $(
					`<div class="mobile-menu-back-button" title="Go Back">${buttonSvg}</div>`
				);

				//* Grab all existing back buttons
				const existingBackButtons = headerNav.find('.mobile-menu-back-button');

				//* Hide all existing back buttons add required aria tags
				existingBackButtons.each(function (index, item) {
					$(item).attr('aria-hidden', 'true');
					$(item).attr('tabindex', '-1');
				});

				//* Show new back button and add required aria tags
				backButton.attr('aria-hidden', 'false');
				backButton.attr('tabindex', '0');

				//* Append new back button to headerNav
				headerNav.append(backButton);

				const handleMobileMenuBackButtonClick = () => {
					collapseMobileMenu(event);
					backButton.detach();

					//* Find all existing back buttons and show the last one and add required aria tags
					const existingBackButtons = headerNav.find('.mobile-menu-back-button');
					existingBackButtons.last().attr('aria-hidden', 'false');
					existingBackButtons.last().attr('tabindex', '0');

					parent.children('a').focus();
				};

				backButton.on('click', handleMobileMenuBackButtonClick);
				backButton.on('keydown', function (event) {
					if (event.keyCode === 13) {
						handleMobileMenuBackButtonClick(event);
					}
				});
			};

			const handleMobileMenuClick = function (event) {
				const parent = $(this).parent(); // menu-item

				if (parent.hasClass('ready-to-expand')) {
					//* do something on second click, normally links to link page
				} else {
					createMobileBackButton(event);
					expandMobileMenu(event);
				}
			};

			const setSubmenuSideBufferHeight = function () {
				const submenus = $('.main-menu > .menu-item > .sub-menu');

				submenus.each(function (index, item) {
					const submenu = $(item).attr('data-index', index);
					var value = submenu.innerHeight();

					//* create style element
					const style = $(`<style type="text/css">`);

					//* add styling to style element
					style.append(
						`.main-menu > .menu-item > .sub-menu[data-index="${index}"]::after{height:${value}px;}`
					);
					style.append(
						`.main-menu > .menu-item > .sub-menu[data-index="${index}"]::before{height:${value}px;}`
					);

					//* append style element to document body
					$('body').append(style);
				});
			};

			// Is Mobile
			if (this.window.innerWidth < mobileWidth) {
				console.log($('.main-menu').find('.menu-item').children('a'));
				$('.main-menu').find('.menu-item').children('a').on('click', handleMobileMenuClick);
			} else {
				$('.main-menu').children().on('mouseenter', addSubmenuExpandedClass);
				$('.main-menu').children().on('mouseleave', removeSubmenuExpandedClass);
				$('.main-menu > .menu-item > .sub-menu')
					.children()
					.find('a')
					.on('focus', addSubmenuExpandedClass);
				$('.main-menu > .menu-item > .sub-menu')
					.children()
					.find('a')
					.on('blur', removeSubmenuExpandedClass);

				setSubmenuSideBufferHeight();
			}

			$mobileMenuToggle.on('click', function () {
				$('header').toggleClass('mobile-menu-expanded');
				collapseAllMobileMenus();
			});
			$mobileMenuToggle.on('keydown', function (event) {
				if (event.keyCode === 13) {
					$('header').toggleClass('mobile-menu-expanded');
					collapseAllMobileMenus();
				}
			});
		});
	},
	bindElements: function () {}
};
